export const demoUser = {
  id: 404404,
  username: "ghost_user",
  first_name: "Ghost",
};

export const demoOrders = [
  {
    name: "Худи Ghost404",
    paid_cost: "8 990",
    date: "2026-06-14",
    address: "Москва",
    size: "L",
    count: 1,
  },
  {
    name: "Футболка Ghost404",
    paid_cost: "3 490",
    date: "2026-05-28",
    address: "Москва",
    size: "M",
    count: 2,
  },
];

export const demoReferrals = [
  {
    date: "2026-07-18",
    for_this: "Реферальная покупка",
    count: 120,
    username: "alex404",
    photo_url: "https://placehold.co/80x80/252525/FFFFFF?text=A",
  },
  {
    date: "2026-07-12",
    for_this: "Пригласил пользователя",
    count: 100,
    username: "cyberfox",
    photo_url: "https://placehold.co/80x80/252525/FFFFFF?text=C",
  },
  {
    date: "2026-07-03",
    for_this: "Покупка на сайте",
    count: -350,
    username: "ghost_user",
    photo_url: "https://placehold.co/80x80/252525/FFFFFF?text=G",
  },
];

export const demoReferralLink =
  "https://t.me/ghosted404_bot?start=404404";
